var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.conditionShow)?_c('div',{key:_vm.count},[(_vm.position == 'bottom')?_c('render-input',{attrs:{"input":{type:'section', text:'Danger Zone'}}}):_vm._e(),_vm._l((_vm.items),function(item){return _c('case-action',{key:item.title,attrs:{"item":item}})})],2):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }